import { useField } from 'formik';

import styled from '@emotion/styled';

import { FilePond, registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const Container = styled.div`
  /* .filepond--list, .filepond--credits {
    display: none;
  } */
`

const FileZone = ({ name, labelIdle = 'Drag & Drop your files or <span class="filepond--label-action">Browse</span>', ...props }) => {
  const [field, meta, helpers] = useField(name);
  
  return (
    <Container>
      <FilePond
        files={field.value || []}
        allowReorder={true}
        onupdatefiles={(fileItems) => {
          // Extract the actual files
          helpers.setValue(fileItems.map(item => item.file));
        }}
        allowMultiple={true}
        labelIdle={labelIdle}
        credits={false}
        {...props}
      />
      {/* {meta.touched && meta.error && (
        <div style={{ color: 'red', fontSize: '12px' }}>
          {meta.error}
        </div>
      )} */}
    </Container>
  );
};

export default FileZone;